import classNames from 'classnames'
import React, { useCallback, type JSX } from 'react'
import Icon, { IconName } from '../icon'

export type ButtonGroupItemType = {
  id: string
  title: JSX.Element | string
  icon?: IconName
}

type Props = {
  items: ButtonGroupItemType[]
  activeId: string
  onClick: (arg0: string) => void
}

const ButtonGroup = ({ items, activeId, onClick }: Props) => {
  const titleWithIcon = useCallback(
    (icon: IconName, title: JSX.Element | string) => (
      <div className="d-flex align-items-center">
        <Icon name={icon} className="i-16 u-mr-8" />
        <span className="u-fs-12">{title}</span>
      </div>
    ),
    []
  )

  return (
    <div className="c-button-group">
      {items.map((item, key) => (
        <button
          className={classNames('u-outline-inset c-button-group__btn', {
            'c-button-group__btn--active': activeId === item.id,
          })}
          onClick={() => onClick(item.id)}
          key={item.id + key}>
          {item.icon ? titleWithIcon(item.icon, item.title) : item.title}
        </button>
      ))}
    </div>
  )
}

export default ButtonGroup
